import React from 'react';
import useDialogStore from '../store/useDialogStore';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiAlertTriangle, FiHelpCircle } = FiIcons;

const GlobalConfirmationDialog = () => {
  const { isOpen, title, message, confirmText, cancelText, onConfirm, onCancel, closeDialog, variant } = useDialogStore();

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (onConfirm) onConfirm();
    closeDialog();
  };

  const handleCancel = () => {
    if (onCancel) onCancel();
    closeDialog();
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/50 backdrop-blur-sm animate-in fade-in duration-200 p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden animate-in zoom-in-95 duration-200 ring-1 ring-gray-900/5">
        <div className="p-6">
          <div className="flex items-start gap-4">
            <div className={`w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 ${
              variant === 'danger' ? "bg-red-50 text-red-600" : "bg-[#1E2937]/5 text-[#1E2937]"
            }`}>
              <SafeIcon 
                icon={variant === 'danger' ? FiAlertTriangle : FiHelpCircle} 
                className="text-2xl" 
              />
            </div>
            <div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{message}</p>
            </div>
          </div>
        </div>
        
        <div className="bg-gray-50 px-6 py-4 flex justify-end gap-3 border-t border-gray-100">
          <button 
            onClick={handleCancel}
            className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 font-medium text-sm transition-colors shadow-sm"
          >
            {cancelText}
          </button>
          <button 
            onClick={handleConfirm}
            className={`px-4 py-2 text-white rounded-lg font-medium text-sm transition-colors shadow-sm ${
              variant === 'danger' ? "bg-red-600 hover:bg-red-700" : "bg-[#1E2937] hover:bg-gray-800"
            }`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default GlobalConfirmationDialog;